// Os textos das chaves que a API de Campanhas manda em inglês (`campanhas/*`),
// num lugar só: cada grupo mora em `CAMPANHAS.<GRUPO>.<CHAVE>` de `report.json`.
// Chave nova que a tela não conhece aparece crua: melhor que sumir. O código da
// Meta não mora aqui, e sim em `metaErrors.js`.
const GROUPS = {
  // A campanha do Outbound (a2) ou o lote (b1).
  kind: ['KINDS', ['campaign', 'lote']],
  // As etapas do funil, de enviadas a resolvidas.
  step: [
    'STEPS',
    [
      'sent',
      'delivered',
      'read',
      'replied',
      'ai_attended',
      'handed_to_person',
      'resolved',
    ],
  ],
  // Quem atendeu depois da resposta: os cinco somam as respostas.
  after: ['AFTER_REPLY', ['ai', 'person', 'other_bot', 'waiting', 'nobody']],
  // O que houve depois da passagem da IA para a equipe.
  handoff: [
    'AFTER_HANDOFF',
    ['resolveram', 'devolveram', 'ainda_com_equipe', 'ninguem_respondeu'],
  ],
  // As linhas que abrem a lista das conversas.
  line: [
    'LINES',
    [
      'replied',
      'ai',
      'person',
      'other_bot',
      'nobody',
      'waiting',
      'no_reply',
      'failed',
      'opted_out',
    ],
  ],
  // Por que o destinatário foi pulado, sem chegar a ter mensagem.
  skipped: [
    'SKIPPED',
    [
      'opted_out',
      'invalid_phone',
      'duplicate_in_batch',
      'not_materialized',
      'send_error',
    ],
  ],
  // A falha sem código da Meta, pela classe do texto.
  unparsed: ['UNPARSED', ['network', 'http', 'template_not_found', 'other']],
  // Como a pessoa pediu para parar.
  origin: ['ORIGINS', ['meta_131050', 'button', 'text', 'manual']],
  // Onde o envio de uma conversa parou.
  delivery: [
    'DELIVERY',
    ['sent', 'delivered', 'read', 'failed', 'no_confirmation'],
  ],
  // Por que um número sai sem dado.
  reason: [
    'REASONS',
    ['no_capture', 'before_capture', 'no_samples', 'no_replies', 'no_price'],
  ],
  // A categoria de preço da Meta (`pricing.category`), grafada como ela manda:
  // a de autenticação internacional é com hífen.
  category: [
    'COST.CATEGORIES',
    [
      'marketing',
      'marketing_lite',
      'utility',
      'authentication',
      'authentication-international',
      'service',
    ],
  ],
};

const toKey = value => value.toUpperCase().replaceAll('-', '_');

// `group` é uma das chaves de GROUPS; `value`, a chave que a API mandou.
export const campanhasLabel = (t, group, value) => {
  if (value === null || value === undefined || value === '') return '';
  const [prefix, known] = GROUPS[group];
  return known.includes(value)
    ? t(`CAMPANHAS.${prefix}.${toKey(value)}`)
    : String(value);
};

// As chaves conhecidas de um grupo, na ordem em que a tela as mostra.
export const campanhasKeys = group => [...GROUPS[group][1]];
